<div class="tCol clickCol desktop" id="CellOS_{{ item.name }}">
    <div class="chartWrapper">
        <canvas
            baseChart
            [data]="data"
            [options]="options"
            [type]="'line'"
            width="300"
            height="40"
        ></canvas>
    </div>
</div>
